import React from 'react'
import "../styles/SkillTile.css"

const SkillComponent = ({ imageUrl, name }) => {
    return (
        <div className='wrapper'>
            <img src={imageUrl} alt='name'/>
            {name}
        </div>
    )
}

const SkillTile = ({ name, skills }) => {
  return (
    <div className='skill' >
        <h1 className='skillTileName'>{name}</h1>
    <div className='container'>
      {skills.map((skill) => (<SkillComponent key={skill.name} imageUrl={skill.image} name={skill.name}/>))}
    </div>
    </div>
  )
}

export default SkillTile
